import s from './footer.module.scss';

export const StudentOnboardingFooter = () => {
	return (
		<div className="container">
			<div className={s.inner}>
				<ul className={s.list}>
					<li>
						<a href="mailto:contact@sozvuchno.ru">Поддержка</a>
					</li>
					<li>
						<a href="https://sozvuchno.ru/documents" target="_blank" rel="noreferrer">
							Оферта
						</a>
					</li>
					<li>
						<a
							href="https://sozvuchno.ru/user-agreement"
							target="_blank"
							rel="noreferrer"
						>
							Пользовательское соглашение
						</a>
					</li>
				</ul>
			</div>
		</div>
	);
};
